import throttle from '../util/throttle';

const selectors = {
  filtersWrappper: 'data-filters',
  underlay: '[data-filters-underlay]',
  filtersHideDesktop: 'data-default-hide',
  filtersToggle: 'data-filters-toggle',
  focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
  groupHeading: 'data-group-heading',
  showMore: 'data-show-more',
};

const classes = {
  show: 'drawer--visible',
  defaultVisible: 'filters--default-visible',
  hide: 'hidden',
  expand: 'is-expanded',
  hidden: 'is-hidden',
  focusEnable: 'focus-enabled',
};

const sections = {};

class Filters {
  constructor(filters, refresh = false) {
    this.container = filters;
    this.underlay = this.container.querySelector(selectors.underlay);
    this.groupHeadings = this.container.querySelectorAll(`[${selectors.groupHeading}]`);
    this.showMoreButtons = this.container.querySelectorAll(`[${selectors.showMore}]`);
    this.triggerKey = this.container.getAttribute(selectors.filtersWrappper);
    this.selector = `[${selectors.filtersToggle}='${this.triggerKey}']`;
    this.filtersToggleButtons = document.querySelectorAll(this.selector);

    this.connectToggleMemory = (evt) => this.connectToggleFunction(evt);
    this.connectShowHiddenOptions = (evt) => this.showHiddenOptions(evt);

    this.connectToggle(refresh);
    this.onFocusOut();
    this.expandingEvents();

    if (this.getShowOnLoad()) {
      this.showFilters();
    } else {
      this.hideFilters();
    }
  }

  unload() {
    if (this.filtersToggleButtons.length) {
      this.filtersToggleButtons.forEach((element) => {
        element.removeEventListener('click', this.connectToggleMemory);
      });
    }

    if (this.showMoreButtons.length) {
      this.showMoreButtons.forEach((button) => {
        button.removeEventListener('click', this.connectShowHiddenOptions);
      });
    }
  }

  expandingEvents() {
    if (this.showMoreButtons.length) {
      this.showMoreButtons.forEach((button) => {
        button.addEventListener('click', throttle(this.connectShowHiddenOptions, 500));
      });
    }
  }

  showHiddenOptions(evt) {
    const element = evt.target.hasAttribute(selectors.showMore) ? evt.target : evt.target.closest(`[${selectors.showMore}]`);

    element.classList.add(classes.hidden);

    element.previousElementSibling.querySelectorAll(`.${classes.hidden}`).forEach((option) => {
      option.classList.remove(classes.hidden);
    });
  }

  connectToggle(refresh = false) {
    this.filtersToggleButtons.forEach((button) => {
      const isDynamic = button.closest(`[${selectors.filtersWrappper}]`) !== null;

      if ((isDynamic && refresh) || (isDynamic && !refresh) || (!isDynamic && !refresh)) {
        button.addEventListener('click', this.connectToggleMemory.bind(this));
      }
    });
  }

  connectToggleFunction(evt) {
    const ariaExpanded = evt.currentTarget.getAttribute('aria-expanded') === 'true';
    if (ariaExpanded) {
      this.hideFilters();
    } else {
      this.showFilters();
    }
  }

  onFocusOut() {
    this.container.addEventListener(
      'focusout',
      function (evt) {
        if (window.innerWidth >= window.theme.sizes.medium) {
          return;
        }
        const childInFocus = evt.currentTarget.contains(evt.relatedTarget);
        const isVisible = this.container.classList.contains(classes.show);
        const isFocusEnabled = document.body.classList.contains(classes.focusEnable);
        if (isFocusEnabled && isVisible && !childInFocus) {
          this.hideFilters();
        }
      }.bind(this)
    );

    this.container.addEventListener(
      'keyup',
      function (evt) {
        if (evt.code !== 'Escape') {
          return;
        }
        this.hideFilters();
        this.filtersToggleButtons[0].focus();
      }.bind(this)
    );

    this.underlay.addEventListener(
      'click',
      function () {
        this.hideFilters();
      }.bind(this)
    );
  }

  getShowOnLoad() {
    const selector = `[${selectors.filtersHideDesktop}='false']`;
    const showOnDesktop = document.querySelector(selector);
    const isDesktop = window.innerWidth >= window.theme.sizes.medium;
    if (showOnDesktop && isDesktop) {
      return true;
    } else {
      return false;
    }
  }

  showFilters() {
    this.filtersToggleButtons = document.querySelectorAll(this.selector);
    this.container.classList.remove(classes.hide);
    // animates after display none is removed
    setTimeout(() => {
      this.filtersToggleButtons.forEach((btn) => btn.setAttribute('aria-expanded', true));
      this.filtersToggleButtons.forEach((btn) => btn.classList.add(classes.show));
      this.container.classList.add(classes.show);
      this.container.querySelector(selectors.focusable).focus();
    }, 1);
  }

  hideFilters() {
    this.filtersToggleButtons = document.querySelectorAll(this.selector);
    this.filtersToggleButtons.forEach((btn) => btn.setAttribute('aria-expanded', false));
    this.container.classList.remove(classes.show);
    this.container.classList.remove(classes.defaultVisible);
    this.filtersToggleButtons.forEach((btn) => btn.classList.remove(classes.show));
    this.filtersToggleButtons.forEach((btn) => btn.classList.remove(classes.defaultVisible));
    // adds display none after animations
    setTimeout(() => {
      if (!this.container.classList.contains(classes.show)) {
        this.container.classList.add(classes.hide);
      }
    }, 800);
  }
}

const collectionFiltersSidebar = {
  onLoad() {
    sections[this.id] = [];
    const wrappers = this.container.querySelectorAll(`[${selectors.filtersWrappper}]`);
    wrappers.forEach((wrapper) => {
      sections[this.id].push(new Filters(wrapper));
    });
  },
  onUnload: function () {
    sections[this.id].forEach((filters) => {
      if (typeof filters.unload === 'function') {
        filters.unload();
      }
    });
  },
};

export {collectionFiltersSidebar, Filters};
